/**
 * InfinitSales - carregadores de mensagens por canal (frente C4)
 *
 * Usados pelo PREFETCH no mouseenter da linha (shell) para encher o chatCache
 * com a lista no MESMO formato que o ChatWindow do canal renderiza: ordem
 * crescente, com a mesma normalizacao de timestamp. O ChatWindow continua
 * dono da leitura ao abrir; aqui e so o "esquenta" do cache.
 *
 * Os tamanhos de pagina espelham os PAGE_SIZE de cada ChatWindow (QR 30,
 * Business 30, Instagram 50, Messenger 50).
 */
import whatsappService from '../wa-personal/whatsappService';
import waBusinessService from '../wa-business/waBusinessService';
import instagramService from '../instagram/instagramService';
import messengerService from '../messenger/messengerService';
import widgetService from '../widget/widgetService';

export const CHAT_PAGE_SIZE = {
  wa_personal: 30,
  wa_business: 30,
  instagram: 50,
  messenger: 50,
  widget: 50,
};

// Mesma robustez do getTimestampMs do ChatWindow do Business: ISO, epoch em
// segundos ou em ms, string numerica.
function toMs(t) {
  if (t === undefined || t === null || t === '') return 0;
  if (typeof t === 'number') return t < 10_000_000_000 ? t * 1000 : t;
  const n = Number(t);
  if (!Number.isNaN(n)) return n < 10_000_000_000 ? n * 1000 : n;
  const d = new Date(t).getTime();
  return Number.isNaN(d) ? 0 : d;
}

export async function loadWaPersonalMessages(remoteJid, { signal } = {}) {
  const res = await whatsappService.getChatMessages(remoteJid, CHAT_PAGE_SIZE.wa_personal, { signal });
  const list = res?.data || [];
  return [...list].sort((a, b) => (Number(a.messageTimestamp) || 0) - (Number(b.messageTimestamp) || 0));
}

export async function loadWaBusinessMessages(chatId, { signal } = {}) {
  const res = await waBusinessService.getMessages(chatId, CHAT_PAGE_SIZE.wa_business, 0, { signal });
  const list = res?.data || [];
  return [...list].sort((a, b) => {
    const ta = toMs(a.timestamp) || toMs(a.created_at);
    const tb = toMs(b.timestamp) || toMs(b.created_at);
    return ta - tb;
  });
}

export async function loadInstagramMessages(chatId, { signal } = {}) {
  const res = await instagramService.getMessages(chatId, CHAT_PAGE_SIZE.instagram, 0, { signal });
  return [...(res?.data || [])].reverse();
}

export async function loadMessengerMessages(chatId, { signal } = {}) {
  const res = await messengerService.getMessages(chatId, CHAT_PAGE_SIZE.messenger, 0, { signal });
  return [...(res?.data || [])].reverse();
}

export async function loadWidgetMessages(chatId, { signal } = {}) {
  const res = await widgetService.getMessages(chatId, CHAT_PAGE_SIZE.widget, 0, { signal });
  return [...(res?.data || [])].reverse();
}

const chatMessageLoaders = {
  wa_personal: loadWaPersonalMessages,
  wa_business: loadWaBusinessMessages,
  instagram: loadInstagramMessages,
  messenger: loadMessengerMessages,
  widget: loadWidgetMessages,
};

export default chatMessageLoaders;
